import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
    providedIn: 'root'
})
export class PaisesService {

    constructor(private api: ApiService) {}

    /**
     * Lista países. `item`/`valor` opcionales filtran por columna
     * (`COD_PAIS`, `NOM_PAIS`, `estado`); sin ellos devuelve todo.
     * `_token` es legacy y se ignora (el token va en el header Bearer).
     */
    mostrarPaises(_token?: any, item?: any, valor?: any): Observable<{ rows: any[] }> {
        const data = item && item !== 'null' ? { field: item, value: valor } : {};
        return this.api.post('/company/countries/list', data);
    }

}
